<template>
  <div id="pers-tab5" name="hrms32e-tab5" class="content-pers">
    <div class="card-ui card-ui-center clearfix border-top-color-skin">
      <div class="sub-topic-box clearfix" @click="toggleSubTopic1">
        <i class="fa fa-user icon-sub-topic" aria-hidden="true"></i>
        <div class="sub-topic">{{ labels['HRMS32EC1']['140'] }}</div>
      </div>

      <div class="data-box clearfix" v-show="subTopic1">
        <div class="data-row">
          <div class="col-xs-5 data-label">{{ labels['HRMS32EC11']['10'] }}</div>
          <div class="col-xs-7 data-input">
            <hrms-dropdown  v-model="detail.typrewd" 
                            :options="arrTyprewd[nowLang]"
                            style="margin-bottom: 5px;" />
          </div>
        </div>
        <div class="data-row">
          <div class="col-xs-5 data-label">{{ labels['HRMS32EC11']['30'] }}</div>
          <div class="col-xs-7 data-input">
            <input type="text" class="form-control input-text" id="numhmref" name="numhmref"
                   maxlength="16"
                   v-model="detail.numhmref" 
                   v-validate="'max:16'"
                   data-vv-name="numhmref"
                   :has-error="errors.has('numhmref')" />
            <div class="text-error" v-show="errors.has('numhmref')">{{errors.first('numhmref')}}</div>
          </div>
        </div>
        <div class="data-row">
          <div class="col-xs-5 data-label">{{ labels['HRMS32EC11']['20'] }}</div>
          <div class="col-xs-7 data-input">
            <textarea class="form-control textarea-text" id="desrewd1" name="desrewd1" 
                      maxlength="150"
                      v-model="detail.desrewd1" 
                      v-validate="'max:150'"
                      data-vv-name="desrewd1"
                      :has-error="errors.has('desrewd1')" ></textarea>
            <div class="text-error" v-show="errors.has('desrewd1')">{{errors.first('desrewd1')}}</div>
            <div class="remark-limit-character">{{ dispLimitLabel(150) }}</div> 
          </div>
        </div>
      </div>
    </div>

    <div class="col-xs-12 box-footer">
      <button type="button" class="btn bg-color-skin" @click="callSave()" v-if="validateStaappr"><i class="fa fa-check-circle"></i>{{ labelsButton['save'] }}</button>
      <button type="button" class="btn bg-dark-gray pull-left" @click="togglePage(0)" value="Back"><i class="fa fa-chevron-circle-left"></i>{{ labelsButton['back'] }}</button>   
    </div>
      
  </div>
</template>

<script>
import { constLabels } from 'assets/js/constLabels.js'

export default {
  name: 'hrms32e-tab5',
  data () {
    return {
      subTopic1: true
    }
  },
  watch: {
    'detail.numhmref' () {
      this.$validator.validate('numhmref', this.detail.numhmref).catch(e => {})
    },
    'detail.desrewd1' () {
      this.$validator.validate('desrewd1', this.detail.desrewd1).catch(e => {})
    },
    detail () {
      this.$nextTick(() => {
        this.errors.clear()
      })
    }
  },
  methods: {
    dispLimitLabel (limit) {
      return constLabels('limitTo') + ' ' + limit + ' ' + constLabels('characters')
    },
    toggleSubTopic1 () {
      this.subTopic1 = !this.subTopic1
    },
    saveParams () {
      return {
        p_dtereq: this.searchDetail.dtereq,
        p_numseq: this.indexSelected.numseq,
        n_codrewd: this.detail.typrewd,
        n_numhmref: this.detail.numhmref,
        n_desrewd1: this.detail.desrewd1,
        p_codempid_query: this.searchDetail.codempid_query
      }
    },
    callSave () {
      this.$validator.validateAll().then(result => {
        if (result && this.searchDetail.codempid_query !== '') {
          this.postDetail5Save({ saveParams: this.saveParams(), searchIndex: this.searchIndex, togglePage: this.togglePage })
        }
      })
    }
  },
  props: [ 'nowLang', 'labels', 'detail', 'indexSelected', 'pcDisp', 'togglePage', 'labelsButton', 'arrTyprewd', 'postDetail5Save', 'searchDetail', 'searchIndex', 'validateStaappr' ]
}
</script>


// WEBPACK FOOTER //
// tab5.vue?55b870dc